.wrapper {
  position: relative;
}

.menu {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: auto;
  margin: 0;
  padding: var(--ns-space-2) var(--ns-space-3);
  position: relative;
  list-style: none;
  cursor: pointer;
  border: none;
  border-radius: var(--ns-border-radius-pill);
  background-color: var(--ns-color-grey-light);
  transition: background-color 0.2s ease;
}

.menu {
  color: var(--ns-color-black);
  font-family: inherit;
  font-weight: var(--ns-weight-regular);
  font-size: var(--ns-font-size-4);
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}



.menu:hover {
  background-color: var(--ns-color-grey);
}

.menu:focus {
  outline: none;
  background-color: var(--ns-color-primary-light);
}
